module.exports = __webpack_public_path__ + "static/media/Hydra.55225b29.png";